import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { DashboardsAnalyticsRuntimeProps } from './DashboardsAnalyticsPage.entrypoint.types.tsx';

type DashboardsAnalyticsEntryPointComponent = EntryPointComponent<
	{},
	{},
	DashboardsAnalyticsRuntimeProps,
	{}
>;

export const dashboardsAnalyticsEntryPoint: EntryPoint<
	DashboardsAnalyticsEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForInteraction<DashboardsAnalyticsEntryPointComponent>(
		/* webpackChunkName: "dashboards-analytics-entrypoint" */ './DashboardsAnalyticsPage.tsx',
	),
	getPreloadProps: (_params: EntryPointRouteParams) => ({}),
});
